module.exports = __webpack_public_path__ + "static/media/3_ic_irtotavara_b.a4e34b24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/3_ic_irtotavara_b.svg
// module id = 1182
// module chunks = 0